import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import styles from './MenuIcon.module.scss';

const MenuIcon = ({ isOpen }) => {
  return (
    <div className={clsx(styles.menuIcon, isOpen && styles.isOpen)}>
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
    </div>
  );
};

MenuIcon.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default MenuIcon;
